import request from "../request";

export const getYears = () =>
  request.get("setting/year").then((res) => res);

export const createYear = (data) =>
  request.post("setting/year", data).then((res) => res);

export const updateYear = (id, data) =>
  request.put(`setting/year/${id}`, data).then((res) => res);

export const deleteYear = (id) =>
  request.delete(`setting/year/${id}`).then((res) => res);
